'use strict';

angular.module('amexReconciliationApp')
  .component('transactionListFilterTab', {
    templateUrl: 'scripts/views/components/transaction-list-filter-tab.html',
    bindings: {
      filterName: '@'
    },
    controller: function (TransactionTabFilterModel,
                          TransactionFilterModel,
                          SearchModel,
                          TransactionsModel,
                          TransactionCountModel,
                          AdobeAnalyticsService
                          ) {
      var self = this;
      var camelFilterName = _.camelCase(self.filterName);
      self.translationKey = 'searches.' + camelFilterName;

      AdobeAnalyticsService.setActiveTabForAnalytics('all');
      self.selectFilter = function () {
        TransactionTabFilterModel.activeTab(self.filterName);
        TransactionFilterModel.filter('');
        AdobeAnalyticsService.setActiveTabForAnalytics(self.filterName);
      };

      self.active = function () {
        return TransactionTabFilterModel.isTabActive(self.filterName);
      };

      self.displayCloseIcon = function () {
        return self.filterName === 'search-results';
      };

      self.closeSearchTab = function () {
        if(TransactionTabFilterModel.isTabActive('search-results')) {
          TransactionTabFilterModel.activeTab('all');
          TransactionFilterModel.filter('');
          AdobeAnalyticsService.setActiveTabForAnalytics(self.filterName);
        }

        SearchModel.closeSearch();
      };

      self.transactionCount = function () {
        var manyTransactions = TransactionsModel.transactionCount() > TransactionsModel.maxTransactions();

        if (manyTransactions) {
          switch (self.filterName) {
            case 'all': return TransactionsModel.transactionCount();
            case 'search-results': return TransactionCountModel[camelFilterName]();
            default: return '';
          }
        } else {
          return TransactionCountModel[camelFilterName]();
        }
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionListFilterTab.js
// module id = 492
// module chunks = 0